(() => {
  const sortScope = 'facet-filters-form[data-ba-entry-price-sort]';
  const normalizePriceSort = (parameters) => {
    if (!document.querySelector(sortScope)) return false;
    if (!['price-ascending', 'price-descending'].includes(parameters.get('sort_by'))) return false;
    parameters.delete('sort_by');
    parameters.delete('page');
    return true;
  };
  const initialUrl = new URL(window.location.href);
  if (normalizePriceSort(initialUrl.searchParams)) {
    window.location.replace(initialUrl.href);
    return;
  }
  const FacetForm = customElements.get('facet-filters-form');
  if (FacetForm && !FacetForm.baTokyoModePatched) {
    const nativeRenderPage = FacetForm.renderPage;
    FacetForm.renderPage = function (searchParams, ...args) {
      const catalog = document.querySelector('[data-ba-mode-view]');
      const parameters = new URLSearchParams(searchParams);
      if (catalog) parameters.set('view', catalog.dataset.baModeView);
      if (normalizePriceSort(parameters) && args[1] === false) {
        const url = new URL(window.location.href);
        url.search = parameters.toString();
        history.replaceState({ ...history.state, searchParams: parameters.toString() }, '', `${url.pathname}${url.search}${url.hash}`);
      }
      return nativeRenderPage.call(this, parameters.toString(), ...args);
    };
    FacetForm.baTokyoModePatched = true;
  }
  if (customElements.get('ba-tokyo-filters-toggle')) return;
  customElements.define('ba-tokyo-filters-toggle', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.catalog = this.closest('[data-ba-mode-view]');
      this.wrap = this.catalog?.querySelector('.facets-wrap');
      this.sidebar = this.catalog?.querySelector('.collection-layout-sidebar');
      if (!this.button || !this.wrap || !this.sidebar) return;
      this.toggle = () => {
        const expanded = this.wrap.classList.toggle('collection-layout-with-sidebar');
        this.sidebar.classList.toggle('is-collapsed', !expanded);
        this.button.classList.toggle('is-expanded', expanded);
        this.button.setAttribute('aria-expanded', String(expanded));
        this.button.querySelector('span').textContent = expanded
          ? window.productGridStrings.hideFilters
          : window.productGridStrings.showFilters;
      };
      this.button.setAttribute('aria-expanded', String(this.wrap.classList.contains('collection-layout-with-sidebar')));
      this.button.addEventListener('click', this.toggle);
    }
    disconnectedCallback() {
      this.button?.removeEventListener('click', this.toggle);
    }
  });
})();
